(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"]) return;
  try {
    
  class AnnouncementBar extends HTMLElement {
    constructor() {
      super()
    }

    handleClick(e) {
      e.preventDefault()
      const {closeAnnouncement} = e.target.dataset
      if (closeAnnouncement === 'row') {
        e.target.closest('.announcement-bar__row').remove()
      } else {
        this.remove()
      }
    }

    connectedCallback() {
      if (this.querySelector('.announcement-bar__close')) {
      this.querySelector('.announcement-bar__close').addEventListener('click', this.handleClick.bind(this))
      }
    }
  }

  customElements.define('announcement-bar', AnnouncementBar)

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
class FooterCollapsible extends HTMLElement {
  constructor() {
    super();

    this.details = this.querySelector('details');
    this.summary = this.querySelector('summary');
    this.summaryIsEmpty = this.summary.textContent.trim().length == 0;
		this.openDefault = this.dataset.openDefault === 'true'

    this.details.addEventListener('keyup', (event) => event.code.toUpperCase() === 'ESCAPE' && this.close());
    this.summary.addEventListener('click', this.onSummaryClick.bind(this));
    document.addEventListener('matchTablet', this.close.bind(this));
    document.addEventListener('unmatchTablet', this.open.bind(this));

    if (FoxThemeSettings.isTablet) {
			if (!this.openDefault) this.close()
    }

		document.addEventListener('matchTablet', () => {
			if (!this.openDefault) {
				this.close()
			} else {
				this.open()
			}
		})

		document.addEventListener('unmatchTablet', () => {
			this.open()
		})
		
  }

  onSummaryClick(event) {
    event.preventDefault();
    event.target.closest('details').hasAttribute('open')
      ? this.close()
      : this.open();
  }

  open() {
    this.details.setAttribute('open', true);
  }

  close() {
    !this.summaryIsEmpty && this.details.removeAttribute('open');
  }
}

customElements.define('footer-collapsible', FooterCollapsible);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mobile-sticky-bar"]) return;
  try {
    
  class MobileStickyBar extends HTMLElement {
    constructor() {
      super()
      document.body.classList.add('mobile-sticky-bar-enabled')
    }
  }
  customElements.define('mobile-sticky-bar', MobileStickyBar)


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["widerruf-formular"] && !Shopify.designMode) return;
  try {
    
  // Eigenes Submit-Handling: das Theme faengt Contact-Forms ab (preventDefault),
  // daher uebernimmt dieses Element den Versand vollstaendig selbst.
  // Die Eingangsbestaetigung ist rechtlich-transaktional und darf NICHT von
  // Marketing-Cookie-Consent abhaengen. Daher primaer ueber die Klaviyo
  // Client-Events-API (consent-frei, serverseitig erfasst), Onsite als Fallback.
  // Der Klaviyo-Flow "Widerruf eingereicht" versendet anschliessend die
  // Eingangsbestaetigung an den Kunden und eine interne Kopie an den Shop.
  class WiderrufForm extends HTMLElement {
    constructor() {
      super();
      this.metric = this.dataset.metric || 'Widerruf eingereicht';
      this.klaviyoKey = this.dataset.klaviyoKey || '';
      this.submitted = false;
    }

    connectedCallback() {
      this.form = this.querySelector('form');
      this.successEl = this.querySelector('.widerruf-success');
      if (!this.form) return;
      this.orderField = this.form.querySelector('[name="contact[Bestellnummer]"]');
      if (this.orderField) {
        // Leniente Format-Pruefung (kein Existenz-Check, nur Form: # + 3-6 Ziffern).
        this.orderField.addEventListener('input', () => this.validateOrder(false));
        this.orderField.addEventListener('blur', () => this.validateOrder(true));
      }
      // Capture-Phase + stopImmediatePropagation, um den Theme-Handler zu umgehen.
      this.form.addEventListener('submit', this.onSubmit.bind(this), true);
    }

    validateOrder(normalize) {
      const el = this.orderField;
      if (!el) return true;
      let v = el.value.trim().replace(/\s+/g, '');
      if (normalize && v && /^\d+$/.test(v)) {
        v = '#' + v; // fuehrende Raute ergaenzen
        el.value = v;
      }
      const ok = v === '' || /^#?\d{3,6}$/.test(v);
      el.setCustomValidity(ok ? '' : 'Bitte gib deine Bestellnummer wie in der Bestätigung an, zum Beispiel #8321.');
      return ok;
    }

    async onSubmit(event) {
      event.preventDefault();
      event.stopImmediatePropagation();
      if (this.submitted) return;
      this.validateOrder(true);
      if (!this.form.reportValidity()) return;
      this.submitted = true;

      const button = this.form.querySelector('button[type="submit"]');
      if (button) {
        button.disabled = true;
        button.textContent = 'Wird gesendet …';
      }

      const val = (sel) => {
        const el = this.form.querySelector(sel);
        return el ? el.value.trim() : '';
      };
      const now = new Date();
      const data = {
        email: val('[name="contact[email]"]'),
        name: val('[name="contact[Name]"]'),
        order: val('[name="contact[Bestellnummer]"]'),
        reason: val('[name="contact[Widerrufsgrund (freiwillig)]"]'),
        time: now.toISOString(),
        readable: this.formatStamp(now)
      };

      await this.sendEvent(data);
      this.showSuccess(data.readable);
    }

    formatStamp(d) {
      const pad = (n) => String(n).padStart(2, '0');
      return pad(d.getDate()) + '.' + pad(d.getMonth() + 1) + '.' + d.getFullYear() +
        ' um ' + pad(d.getHours()) + ':' + pad(d.getMinutes()) + ' Uhr';
    }

    async sendEvent(data) {
      let sent = false;
      // 1. Primaer: Client-Events-API (consent-frei, serverseitig bei Klaviyo erfasst)
      if (this.klaviyoKey && data.email) {
        const payload = {
          data: {
            type: 'event',
            attributes: {
              metric: { data: { type: 'metric', attributes: { name: this.metric } } },
              profile: { data: { type: 'profile', attributes: { email: data.email } } },
              properties: {
                Bestellnummer: data.order,
                Name: data.name,
                'Widerrufsgrund': data.reason,
                Eingang: data.time,
                'Eingang_lesbar': data.readable
              },
              time: data.time
            }
          }
        };
        try {
          const res = await fetch('https://a.klaviyo.com/client/events/?company_id=' + encodeURIComponent(this.klaviyoKey), {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', revision: '2024-10-15' },
            keepalive: true,
            body: JSON.stringify(payload)
          });
          sent = !!res && res.ok;
        } catch (e) { sent = false; }
      }
      // 2. Fallback NUR wenn die Client-API fehlschlug (sonst Doppel-Event -> Doppelmail)
      if (!sent) {
        try {
          window.klaviyo = window.klaviyo || [];
          if (data.email) window.klaviyo.push(['identify', { '$email': data.email }]);
          window.klaviyo.push(['track', this.metric, {
            Bestellnummer: data.order,
            Name: data.name,
            'Widerrufsgrund': data.reason,
            Eingang: data.time,
            'Eingang_lesbar': data.readable
          }]);
        } catch (e) { /* ignore */ }
      }
    }

    showSuccess(stamp) {
      if (this.successEl) {
        const timeEl = this.successEl.querySelector('.widerruf-success__time');
        if (timeEl) {
          timeEl.textContent = stamp || this.formatStamp(new Date());
        }
        this.successEl.hidden = false;
        this.successEl.focus && this.successEl.setAttribute('tabindex', '-1');
      }
      this.form.hidden = true;
      if (this.successEl) {
        this.successEl.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    }
  }

  if (!customElements.get('widerruf-form')) {
    customElements.define('widerruf-form', WiderrufForm);
  }

  } catch(e) { console.error(e); }
})();
})();
